module.exports = __webpack_public_path__ + "static/GlitchlessSonyax48-55b873f3526feea2a2919bf28855e351.png";